import { IonButton } from "@ionic/react";
import { TestType } from "../../models/Enums";
import { isRemoteControl } from "../../utils/assessment-control";
import RemoteStartHint from "../RemoteStartHint";

interface Props {
  setRaiseHand: Function;
  persistentMode?: boolean;
}
const RaiseHandModal: React.FC<Props> = ({ setRaiseHand, persistentMode = false }) => {
  const selectedAssessment = sessionStorage.getItem("selectedAssesment");
  const phaseNo = sessionStorage.getItem("phaseNo");
  // Remote control mode: the remote's Start button replaces the hand raise and voice commands
  const remoteControl = isRemoteControl();
  const startAction = remoteControl
    ? "press Start on the remote"
    : "raise hand above eye level or say 'we are ready'";
  return (
    <>
      <div className={`raise-hand-modal text-center flex-column ${persistentMode ? 'persistent-mode' : ''}`}>
        {remoteControl ? (
          // The remote with Start/Stop highlighted instead of the raised-hand icon
          <RemoteStartHint height={persistentMode ? 220 : 520} />
        ) : (
          <svg
            width="436"
            height="280"
            viewBox="0 0 436 280"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M164.095 0.188625C151.49 1.5133 140.337 6.84979 131.374 15.8441C123.861 23.3816 118.984 32.3661 116.694 42.8883C115.639 47.7305 115.627 59.1412 116.67 64.0245C118.14 70.9064 120.879 77.4806 124.716 83.3317C127.376 87.3886 135.213 95.2639 139.24 97.9254C147.749 103.55 156.601 106.481 166.569 106.974C178.35 107.556 188.977 104.63 198.914 98.0677C206.418 93.1113 212.494 86.3395 216.693 78.2508C220.912 70.1248 222.683 62.8523 222.683 53.6596C222.683 39.1809 217.761 26.9186 207.77 16.5095C199.967 8.37973 190.66 3.26923 179.617 1.04871C174.947 0.109365 168.333 -0.256862 164.095 0.188625ZM13.2135 15.2206C9.9683 16.2583 7.69046 17.687 5.43091 20.1026C1.1175 24.714 -0.307979 31.0215 1.4195 37.8522C3.46687 45.9486 10.3305 60.9529 17.3887 72.7635C27.2675 89.2929 37.8746 103.511 60.5997 130.685C66.1151 137.28 72.1161 144.748 73.9355 147.281C88.7625 167.92 97.5971 191.804 101.079 220.666C102.412 231.717 102.734 238.221 102.998 259.433L103.253 279.858H170.659H238.065L238.17 255.207L238.275 230.557L241.189 236.205C247.379 248.206 252.624 262.33 256.755 278.131L257.207 279.858H278.955H300.704L300.447 278.334C299.896 275.068 296.457 259.837 294.962 254.047C291.787 241.751 282.912 211.533 279.8 202.426C266.27 162.844 249.155 142.635 221.442 133.52C210.504 129.922 198.999 128.121 182.589 127.436C157.254 126.379 150.055 125.497 137.604 121.922C122.867 117.691 107.933 109.91 95.8029 100.144C77.7465 85.605 62.4744 66.7064 38.8835 29.7066C34.0018 22.0504 31.7472 19.358 28.4828 17.2866C24.1373 14.5296 17.9801 13.6963 13.2135 15.2206Z"
              fill="#802392"
            />
            <path
              d="M424.539 0H320.864C314.922 0 310.108 4.81345 310.108 10.7563V50.6676L286.622 70.5129C282.793 73.7506 285.084 80 290.091 80H424.539C430.482 80 435.295 75.1866 435.295 69.2437V10.7563C435.295 4.81345 430.482 0 424.539 0ZM377.357 55.0077H342.103C339.43 55.0077 337.262 52.8403 337.262 50.1674C337.262 47.4945 339.43 45.3271 342.103 45.3271H377.357C380.03 45.3271 382.197 47.4945 382.197 50.1674C382.197 52.8403 380.03 55.0077 377.357 55.0077ZM403.301 34.6299H342.103C339.43 34.6299 337.262 32.4625 337.262 29.7896C337.262 27.1166 339.43 24.9492 342.103 24.9492H403.301C405.974 24.9492 408.141 27.1166 408.141 29.7896C408.141 32.4625 405.974 34.6299 403.301 34.6299Z"
              fill="#802392"
            />
          </svg>
        )}
        {!persistentMode && (
          <>
            <h1 className="fz-30 fw-700 text-center lh-normal mb-0 align-center">
              Therapist should{" "}
            </h1>
            <h1 className="fz-30 fw-700 text-center lh-normal mb-0 align-center">
              {startAction}
            </h1>
            <h1 className="fz-30 fw-700 text-center lh-normal mb-0 align-center">
              to
              {Number(selectedAssessment) === TestType.gait ||
              Number(selectedAssessment) === TestType.tug ||
              Number(selectedAssessment) === TestType.ctsib ||
              Number(selectedAssessment) === TestType.reach ||
              Number(selectedAssessment) === TestType.upper_body_arom
                ? " begin."
                : " calibrate."}
            </h1>
          </>
        )}
        {persistentMode && (
          <h1 className="fz-30 fw-700 text-center lh-normal mb-0 align-center" style={{ color: 'white' }}>
            {startAction.charAt(0).toUpperCase() + startAction.slice(1)}
          </h1>
        )}
      </div>
    </>
  );
};
export default RaiseHandModal;
